module.exports = __webpack_public_path__ + "static/media/foodcoLogoWhite.23ed86be.png";